import assign from 'lodash/assign'
import omit from 'lodash/omit'
import * as Popper from 'popper.js'
import React, { FC, ReactNode, useState } from 'react'
import { Tooltip, CSSModule } from 'reactstrap'

type TTooltipBase = React.HTMLAttributes<HTMLElement> & {
  [key: string]: any
  delay?: number | { show: number; hide: number }
  id: string
  className?: string
  popperClassName?: string
  innerClassName?: string
  message: string | ReactNode
  placement?: Popper.Placement
  modifiers?: Popper.Modifiers
  cssModule?: CSSModule
  fade?: boolean
  flip?: boolean
}
const TooltipBase: FC<TTooltipBase> = (props: TTooltipBase) => {
  const [tooltipOpen, setTooltipOpen] = useState(false)
  const toggle = () => setTooltipOpen(!tooltipOpen)
  const tooltipPlacement = props.placement || 'top'
  const tooltipProps = assign(omit(props, ['id', 'targetNode', 'message']))

  return (
    <Tooltip
      target={props.id}
      placement={tooltipPlacement}
      isOpen={tooltipOpen}
      autohide={false}
      toggle={toggle}
      fade={true}
      delay={100}
      boundariesElement={'viewport'}
      innerClassName={'gray-tip'}
      {...tooltipProps}
    >
      {props.message}
    </Tooltip>
  )
}

export default TooltipBase
